import "scripts/templates/page.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page");
